import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.experiment_guide');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Service } from "src/libs/portal/season/service";

type SlideDirection = 'next' | 'previous';

interface GuideChapter {
    number: string;
    label: string;
    hint: string;
}

@Component({ standalone: false,
    selector: 'wiz-page-xray-experiment_guide',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.experiment_guide/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

.guide-header-button {
  display: inline-flex;
  min-width: 0;
  min-height: 2rem;
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.5rem;
  background: white;
  padding: 0.25rem;
  color: rgb(51, 65, 85);
  font-size: 0.6875rem;
  font-weight: 500;
}

.guide-header-button:hover {
  border-color: rgb(203, 213, 225);
  background: rgb(248, 250, 252);
}

.guide-header-button[aria-current=page] {
  border-color: rgb(125, 211, 252);
  background: rgb(240, 249, 255);
  color: rgb(7, 89, 133);
  font-weight: 600;
}

@media (min-width: 640px) {
  .guide-header-button {
    width: auto;
    gap: 0.375rem;
    padding-inline: 0.625rem;
    font-size: 0.75rem;
  }
}
.guide-toc {
  scrollbar-color: rgb(148, 163, 184) transparent;
  scrollbar-width: thin;
}

.guide-toc::-webkit-scrollbar {
  height: 5px;
}

.guide-toc::-webkit-scrollbar-thumb {
  border-radius: 9999px;
  background: rgb(148, 163, 184);
}

.guide-viewport {
  scroll-margin-top: 4rem;
  touch-action: pan-y;
}

.guide-slide-enter {
  animation: guide-slide-from-right 220ms ease-out both;
}

.guide-slide-enter.guide-slide-from-left {
  animation-name: guide-slide-from-left;
}

.guide-process-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.5rem;
  background: rgb(248, 250, 252);
  padding: 0.75rem 0.5rem;
  text-align: center;
}

.guide-process-card span {
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: rgb(2, 132, 199);
  color: white;
  font-size: 0.625rem;
  font-weight: 700;
}

.guide-process-card strong {
  margin-top: 0.5rem;
  color: rgb(15, 23, 42);
  font-size: 0.75rem;
}

.guide-process-card small {
  margin-top: 0.25rem;
  color: rgb(100, 116, 139);
  font-size: 0.625rem;
  line-height: 1rem;
}

.model-layer-card,
.data-step-card,
.limit-card {
  border-width: 1px;
  border-radius: 0.5rem;
  padding: 0.875rem;
}

.model-layer-card span,
.data-step-card span {
  color: rgb(2, 132, 199);
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.model-layer-card h3,
.data-step-card h3,
.limit-card h3 {
  margin-top: 0.4rem;
  color: rgb(15, 23, 42);
  font-size: 0.75rem;
  font-weight: 700;
}

.model-layer-card p,
.data-step-card p,
.limit-card p {
  margin-top: 0.35rem;
  color: rgb(71, 85, 105);
  font-size: 0.6875rem;
  line-height: 1.25rem;
}

.data-step-card,
.limit-card {
  border-color: rgb(226, 232, 240);
  background: rgb(248, 250, 252);
}

.limit-card > i {
  font-size: 1rem;
}

.guide-route-button {
  display: grid;
  width: 100%;
  min-height: 2.75rem;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.5rem;
  background: white;
  padding: 0.5rem 0.75rem;
  text-align: left;
  color: rgb(15, 23, 42);
  transition: background-color 150ms ease, border-color 150ms ease;
}

.guide-route-button:hover {
  border-color: rgb(125, 211, 252);
  background: rgb(240, 249, 255);
}

.guide-route-button span {
  font-weight: 700;
}

.guide-route-button small {
  min-width: 0;
  color: rgb(100, 116, 139);
  text-align: right;
}

.guide-route-button i {
  color: rgb(2, 132, 199);
}

.guide-nav-button {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid rgb(203, 213, 225);
  border-radius: 0.5rem;
  background: white;
  padding: 0.4rem 0.8rem;
  color: rgb(51, 65, 85);
  font-size: 0.75rem;
  font-weight: 700;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.guide-nav-button:hover:not(:disabled) {
  border-color: rgb(125, 211, 252);
  background: rgb(240, 249, 255);
  color: rgb(3, 105, 161);
}

.guide-nav-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

@keyframes guide-slide-from-right {
  from {
    opacity: 0;
    transform: translateX(2rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes guide-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-2rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 639px) {
  .guide-route-button {
    grid-template-columns: auto 1fr auto;
  }
  .guide-route-button small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media (prefers-reduced-motion: reduce) {
  .guide-slide-enter {
    animation: none;
  }
}`],
})
export class PageXrayExperiment_guideComponent implements OnInit {
    public readonly chapters: GuideChapter[] = [
        { number: '01', label: '전체 흐름', hint: '4개 화면·3개 모델' },
        { number: '02', label: '자세 판정', hint: '카메라·동영상 사용' },
        { number: '03', label: '데이터셋 관리', hint: '업로드·검수·분할' },
        { number: '04', label: '학습실험 공통', hint: '4단계 Candidate 흐름' },
        { number: '05', label: '자세 모델', hint: '관절 좌표 학습' },
        { number: '06', label: '디텍터 모델', hint: '촬영판 위치 학습' },
        { number: '07', label: '자세 판정 모델', hint: '정상·4개 이상 분류' },
        { number: '08', label: '모델 관리', hint: '검증·승인·이력' },
        { number: '09', label: '한계·체크리스트', hint: '안전·운영 확인' }
    ];

    public currentChapter = 0;
    public slideDirection: SlideDirection = 'next';
    private touchStartPoint: { x: number; y: number } | null = null;

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( TranslateService    )         public translate: TranslateService    ) { }

    public get progressPercent(): number {
        return ((this.currentChapter + 1) / this.chapters.length) * 100;
    }

    public async ngOnInit() {
        await this.service.init(this);
    }

    public go(path: string) {
        this.service.href(path);
    }

    public async selectChapter(index: number) {
        const nextIndex = Math.max(0, Math.min(index, this.chapters.length - 1));
        if (nextIndex === this.currentChapter) return;

        this.slideDirection = nextIndex > this.currentChapter ? 'next' : 'previous';
        this.currentChapter = nextIndex;
        await this.service.render();
        this.scrollChapterIntoView(nextIndex);
    }

    public async previousChapter() {
        await this.selectChapter(this.currentChapter - 1);
    }

    public async nextChapter() {
        await this.selectChapter(this.currentChapter + 1);
    }

    public async onCarouselKeydown(event: KeyboardEvent) {
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            await this.previousChapter();
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            await this.nextChapter();
        } else if (event.key === 'Home') {
            event.preventDefault();
            await this.selectChapter(0);
        } else if (event.key === 'End') {
            event.preventDefault();
            await this.selectChapter(this.chapters.length - 1);
        }
    }

    public onTouchStart(event: TouchEvent) {
        const touch = event.changedTouches[0];
        this.touchStartPoint = touch ? { x: touch.clientX, y: touch.clientY } : null;
    }

    public async onTouchEnd(event: TouchEvent) {
        if (this.touchStartPoint === null) return;

        const touch = event.changedTouches[0];
        if (!touch) {
            this.touchStartPoint = null;
            return;
        }

        const distanceX = touch.clientX - this.touchStartPoint.x;
        const distanceY = touch.clientY - this.touchStartPoint.y;
        this.touchStartPoint = null;

        if (Math.abs(distanceX) < 48 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.2) return;
        if (distanceX < 0) await this.nextChapter();
        else await this.previousChapter();
    }

    public trackByChapter(index: number): number {
        return index;
    }

    private scrollChapterIntoView(index: number) {
        if (typeof document === 'undefined') return;

        requestAnimationFrame(() => {
            const reducedMotion = typeof window !== 'undefined'
                && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const behavior: ScrollBehavior = reducedMotion ? 'auto' : 'smooth';
            document.getElementById('guide-toc-' + index)?.scrollIntoView({
                behavior,
                block: 'nearest',
                inline: 'center'
            });
            document.getElementById('guide-viewport')?.scrollIntoView({
                behavior,
                block: 'start'
            });
        });
    }
}

export default PageXrayExperiment_guideComponent;